import Button, {type ButtonProps} from '@gaia/components/Button';
import {useUser} from '@gaia/stores/user';
import gettext from '@gaia/utils/django/gettext';
import type {AuthModalContext} from '@map/contexts/AuthModalContext';

import {MenuItemAnchor} from './MenuItemAnchor';

const sharedProps = {
    children: gettext('Sign Up'),
    href: `/register/`,
};

type ToolbarProps = ButtonProps & {
    setAuthModalState: AuthModalContext;
};

const excludedPaths = new Set(['/', '/register/']);

function Toolbar({style, setAuthModalState, ...props}: ToolbarProps) {
    if (useUser().isAuthenticated) return null;
    if (excludedPaths.has(window.location.pathname)) return null;

    function openAuthModal() {
        if (window.location.pathname === '/login/') {
            window.location.href = `/register/${window.location.search}`;
        } else {
            setAuthModalState({type: 'register', analyticsContext: 'header register'});
        }
    }

    return (
        <Button {...props} onClick={openAuthModal} style={style} appearance='primary'>
            {gettext('Sign Up')}
        </Button>
    );
}

const HamburgerMenu = () => {
    if (useUser().isAuthenticated) return null;
    return <MenuItemAnchor {...sharedProps} />;
};

export const HeaderSignup = {Toolbar, HamburgerMenu};
